import { Campaign, CampaignDateFilterBy, CampaignStatus, CampaignTypeFilter } from '@dev/ee-api/ee-api-models';
import { Action } from 'redux';

export enum ActionTypes {
    GET_CAMPAIGNS = '@@campaigns/GET_CAMPAIGNS',
    UPDATE_CAMPAIGNS_STORE = '@@campaigns/UPDATE_CAMPAIGNS_STORE',
    CAMPAIGNS_ERROR = '@@campaigns/ERROR',
}

export interface GetCampaignsPayload {
    from: string;
    to: string;
    search?: string;
    status?: CampaignStatus[];
    type?: CampaignTypeFilter[];
    dateFilterBy?: CampaignDateFilterBy;
    offset?: number;
    limit?: number;
}

export interface GetCampaingsAction extends Action {
    type: ActionTypes.GET_CAMPAIGNS;
    payload: GetCampaignsPayload;
}

export interface UpdateCampaignsStoreAction extends Action {
    type: ActionTypes.UPDATE_CAMPAIGNS_STORE;
    payload: {
        campaignsList: Campaign[];
    };
}

export interface CampaignsErrorAction extends Action {
    type: ActionTypes.CAMPAIGNS_ERROR;
}

export interface CampaignsState {
    loading: boolean;
    campaignsList?: Campaign[];
}
